import { render, staticRenderFns } from "./booking-pending-approvals-details-dialog-header.vue?vue&type=template&id=48690a45&"
import script from "./booking-pending-approvals-details-dialog-header.vue?vue&type=script&lang=js&"
export * from "./booking-pending-approvals-details-dialog-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports